import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ title, description, ogImage, fullImagePath, keywords, robots }) => {
  const { pathname } = useLocation()

  // Query for default/placeholder values from site metadata in gatsby-config
  const query = graphql`
    query SEO {
      site {
        siteMetadata {
          defaultTitle: title
          titleTemplate
          defaultDescription: description
          siteUrl
          defaultOgImage: ogImage
        }
      }
    }
  `

  const { site } = useStaticQuery(query)

  const { siteUrl, titleTemplate, defaultTitle, defaultDescription, defaultOgImage } = site.siteMetadata

  let imageUrl
  if (ogImage && ogImage !== "undefined" && !ogImage.includes("https:undefined")) {
    imageUrl = fullImagePath ? ogImage : `${siteUrl}${ogImage}`
  } else {
    imageUrl = `${siteUrl}${defaultOgImage}`
  }

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    // image: fullImagePath ? `${ogImage}` : `${siteUrl}${ogImage || defaultOgImage}`,
    image: imageUrl,
    url: `${siteUrl}${pathname}`,
    keywords: String(keywords),
    robots: robots ? String(robots) : null,
  }

  return (
    <Helmet
      title={seo.title}
      titleTemplate={titleTemplate}
      htmlAttributes={{
        lang: "en",
      }}
    >
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {seo.url && <meta name="twitter:card" content="summary_large_image" />}
      {seo.url && <meta property="og:url" content={seo.url} />}
      {seo.url && <meta name="twitter:site" content={seo.url} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.description && <meta property="og:description" content={seo.description} />}
      {seo.description && <meta name="twitter:description" content={seo.description} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
      {seo.image && <meta name="twitter:image" content={seo.image} />}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.robots && <meta name="robots" content={seo.robots} />}
    </Helmet>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  ogImage: PropTypes.string,
}

SEO.defaultProps = {
  title: null,
  description: null,
  ogImage: null,
}
